import { Game } from "./types";

// Kayıtlı oyunlar listesi
const _games: Game[] = [];

/**
 * Bir oyunu kaydeder
 */
export function registerGame(game: Game): void {
  // Zaten kayıtlı mı kontrol et
  if (_games.find((g) => g.id === game.id)) {
    console.warn(`Game with id "${game.id}" is already registered.`);
    return;
  }

  _games.push(game);
}

/**
 * Tüm kayıtlı oyunları döndürür
 */
export function getAllGames(): Game[] {
  return [..._games];
}

/**
 * Belirli bir kategori için oyunları döndürür
 */
export function getGamesByCategory(category: string): Game[] {
  return _games.filter((game) => game.category === category);
}

/**
 * ID ile oyun bulur
 */
export function getGameById(id: string): Game | undefined {
  return _games.find((game) => game.id === id);
}

/**
 * Bir oyunu kaldırır
 */
export function unregisterGame(id: string): void {
  const index = _games.findIndex((game) => game.id === id);
  if (index !== -1) {
    _games.splice(index, 1);
  }
}
